var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('topDiv2',{on:{"openLogin":_vm.openLogin}}),_c('searchFrame'),(_vm.showLogin)?_c('login',{staticStyle:{"width":"50vw","height":"50vh","z-index":"10000","position":"fixed","right":"0"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }